export enum SWAP_ACTIONS {
  SET_SWAP_FX_RATE = 'SWAP_ACTIONS.SET_SWAP_FX_RATE',
  SET_SWAP_FX_RATE_STATUS = 'SWAP_ACTIONS.SET_SWAP_FX_RATE_STATUS',
  SET_SWAP_FX_QUOTE = 'SWAP_ACTIONS.SET_SWAP_FX_QUOTE',
  SET_SWAP_FX_QUOTE_STATUS = 'SWAP_ACTIONS.SET_SWAP_FX_QUOTE_STATUS',
  SET_SWAP_TRANSACTION_LIMITS = 'SWAP_ACTIONS.SET_SWAP_TRANSACTION_LIMITS',
}
